// @ts-nocheck
import { useEffect, useMemo, useState } from 'react'
import { AgGridReact } from '@ag-grid-community/react'

import api from '../api/api'
import GraphDayDetailsModal from './GraphDayDetailsModal'
import {
  getGraphDayLabel,
  getGraphDayState,
  getReasonStripeBackground,
  hasGraphDayDetails,
} from '../utils/graphDay'


function WellMonthAgGrid({ wellId, orgId, onSelectDate }) {
  const [graphData, setGraphData] = useState(null)
  const [selectedDay, setSelectedDay] = useState(null)
  const [bsiDetails, setBsiDetails] = useState(null)

  useEffect(() => {
    if (!wellId) return

    api.get('well-current-graph/', {
      params: {
        well: wellId,
        org: orgId || undefined,
      },
    })
      .then((res) => {
        setGraphData(res.data)
        setSelectedDay(null)
      })
      .catch((err) => console.error(err))
  }, [wellId, orgId])

  const columnDefs = useMemo(() => {
    const daysColumns = Array.from({ length: 31 }, (_, index) => {
      const day = index + 1

      return {
        headerName: String(day),
        field: `d${day}`,
        width: 30,
        minWidth: 30,
        maxWidth: 30,
        headerClass: 'graph-day-header',
        cellClass: 'graph-day-cell',
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        suppressMenu: true,
        menuTabs: [],
        filter: false,
        sortable: false,
        cellStyle: (params) => {

          const isSelected = selectedDay === day

          const value = params.value

          const dayState = getGraphDayState(value)

          // выбранный день КС
          if (isSelected) {
            return {
              background: '#1976d2',
              color: '#fff',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1565c0',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'done_planned' || dayState.kind === 'done') {
            return {
              background: '#81c784',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #66bb6a',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'manual_planned') {
            return {
              background: '#2e7d32',
              color: '#ffffff',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1b5e20',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'manual_outside_plan') {
            return {
              background: 'linear-gradient(to bottom right, #2e7d32 0 calc(50% - 0.5px), #fff calc(50% + 0.5px) 100%)',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #1b5e20',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'done_outside_plan') {
            return {
              background: 'linear-gradient(to bottom right, #81c784 0 calc(50% - 0.5px), #fff calc(50% + 0.5px) 100%)',
              color: '#1b5e20',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #66bb6a',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'ppk_pending') {
            return {
              background: 'linear-gradient(to bottom right, #fff176 0 calc(50% - 0.5px), #66bb6a calc(50% + 0.5px) 100%)',
              color: '#263238',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #9ccc65',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'no_pass') {
            return {
              background: '#fff176',
              color: '#795548',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #fdd835',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'reason') {
            return {
              background: getReasonStripeBackground(dayState.reason),
              color: '#475467',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #98a2b3',
              fontWeight: 'bold',
            }
          }

          if (dayState.kind === 'planned') {
            return {
              background: '#b3e5fc',
              color: '#01579b',
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid #81d4fa',
            }
          }

          // Пусто
          return {
            background: '#fff',
            color: '#333',
            textAlign: 'center',
            cursor: 'pointer',
            border: '1px solid #e0e0e0',
          }
        },
        valueFormatter: (params) => {
          return getGraphDayLabel(params.value)
        },
        onCellClicked: (params) => {
          setSelectedDay(day)

          const year = graphData?.year
          const month = graphData?.month

          if (year && month) {
            const date = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
            onSelectDate(date)
          }

          if (hasGraphDayDetails(params.value)) {
            setBsiDetails({
              month: graphData?.month,
              year: graphData?.year,
              day,
              wellName: graphData?.graph?.well_name,
              value: params.value,
            })
          }
        },
      }
    })

    return [
      {
        headerName: 'Скважина',
        field: 'well',
        width: 120,
        pinned: 'left',
      },
      {
        headerName: 'Подрядчик',
        field: 'org',
        width: 180,
        pinned: 'left',
      },
      ...daysColumns,
    ]
  }, [selectedDay, graphData, onSelectDate])

  const rowData = useMemo(() => {
    if (!graphData) return []

    if (!graphData.found) {
      return []
    }

    const graph = graphData.graph

    const row = {
      well: graph.well_name,
      org: graph.org_name,
    }

    for (let day = 1; day <= 31; day++) {
      row[`d${day}`] = graph.days[String(day)]
    }

    return [row]
  }, [graphData])

  if (!wellId) {
    return null
  }

  if (graphData && !graphData.found) {
    return (
      <div style={emptyStyle}>
        Скважина не найдена в актуальном графике. Заявку можно создать вне графика.
      </div>
    )
  }

  return (
    <>
    <style>{gridCompactStyle}</style>
    <div style={{ margin: '14px' }}>
      <div style={{ marginBottom: '6px', fontSize: '13px', fontWeight: 'bold' }}>
        График скважины за актуальный месяц
      </div>

      <div
        className="ag-theme-alpine well-mini-grid"
        style={{
          height: 62,
          width: '100%',
        }}
      >
        <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            domLayout="normal"
            suppressRowHoverHighlight={true}
            headerHeight={22}
            rowHeight={24}
            suppressMenuHide={true}
          />
      </div>

      <GraphDayDetailsModal
        details={bsiDetails ? {
          ...bsiDetails,
          monthLabel: formatMonthLabel(bsiDetails),
        } : null}
        onClose={() => setBsiDetails(null)}
      />
    </div>
    </>
  )
}

function formatMonthLabel(details) {
  if (!details?.month || !details?.year) return 'актуальный месяц'

  const date = new Date(`${details.year}-${String(details.month).padStart(2, '0')}-01T00:00:00`)

  return new Intl.DateTimeFormat('ru-RU', {
    month: 'short',
    year: '2-digit',
  }).format(date)
}

const emptyStyle = {
  margin: '14px',
  padding: '10px',
  background: '#fff3cd',
  border: '1px solid #ffeeba',
  color: '#856404',
  fontSize: '13px',
}

const gridCompactStyle = `
  .well-mini-grid {
    --ag-font-size: 10px;
    --ag-header-height: 22px;
    --ag-row-height: 24px;
    scrollbar-gutter: stable;
  }

  .well-mini-grid .ag-body-horizontal-scroll {
    display: flex !important;
    height: 16px !important;
    min-height: 16px !important;
    max-height: 16px !important;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport {
    overflow-x: scroll !important;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
    height: 14px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {
    background: #eef2f6;
    border-radius: 7px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
    background: #98a2b3;
    border: 3px solid #eef2f6;
    border-radius: 7px;
  }

  .well-mini-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover {
    background: #667085;
  }

  .well-mini-grid .ag-header-cell {
    padding: 0 !important;
  }

  .well-mini-grid .graph-day-header .ag-header-cell-label {
    justify-content: center !important;
    padding: 0 !important;
  }

  .well-mini-grid .graph-day-header .ag-header-cell-text {
    text-align: center !important;
    width: 100%;
  }

  .well-mini-grid .graph-day-cell {
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    text-align: center !important;
  }

  .well-mini-grid .ag-header-cell-label {
    justify-content: center !important;
    padding: 0 !important;
  }

  .well-mini-grid .ag-header-cell-text {
    font-size: 9px !important;
    line-height: 1 !important;
    font-weight: 600 !important;
  }

  .well-mini-grid .ag-cell {
    font-size: 9px !important;
    padding: 0 !important;
    line-height: 24px !important;
    text-align: center !important;
  }
`

export default WellMonthAgGrid
